import { DatePipe } from '@angular/common';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { AssetsI18nLoader } from '@sla-ng/core';
import { MatPaginatorI18n } from './services/mat-paginatorI18n';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

export function initI18n(i18n: AssetsI18nLoader): () => Promise<void> {
    return (): Promise<void> => i18n.init(null, 'cost-accounting');
}

@NgModule({
    providers: [
        DatePipe,
    ],
    imports: [],
    exports: [],
    declarations: [],

})
export class CostAccountingModule {
    public static forRoot(): ModuleWithProviders<CostAccountingModule> {
        return {
            ngModule: CostAccountingModule,
            providers: [
                { provide: APP_INITIALIZER, useFactory: initI18n, deps: [ AssetsI18nLoader ], multi: true },
                {
                    provide: MatPaginatorIntl, deps: [ TranslateService ],
                    useFactory: (translateService: TranslateService): MatPaginatorIntl => new MatPaginatorI18n(translateService).getPaginatorIntl(),
                },
                { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
            ],
        };
    }
}

